module.exports = __webpack_public_path__ + "img/k_airport.20339d82.jpg";